export default __webpack_public_path__ + "static/media/loyalty.cdf9265f.svg";